import {Component, Inject} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButton, MatIconButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';

@Component({
    selector: 'frog-invitation-link-dialog',
    imports: [
        FormsModule,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        MatIcon,
        MatIconButton,
    ],
    templateUrl: './invitation-link-dialog.component.html',
    styleUrl: './invitation-link-dialog.component.scss',
})
export class InvitationLinkDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: string) {}
    copyToken() {
        navigator.clipboard.writeText(this.data);
    }
}
